import React, { useState } from "react";
import styled from "styled-components";
import DomeHeader from "../components/DomeHeader";
import HowToUseRow from "../components/HowToUseRow";
import SegmentControl from "../components/SegmentControl";
import { Colors } from "../components/styles/Colors";
import { Body, Header2 } from "../components/typography";

const Wrapper = styled.div`
  background: ${Colors.cream2};

  padding: 64px 32px;

  > div {
    max-width: 880px;
    margin: 0 auto;

    text-align: center;

    ${Header2} {
      margin: 24px 0 36px;
    }
  }
`;

export default function BundleHowToUse({ data }) {
  const [mode, setMode] = useState(0);

  if (!data.morningRoutine && !data.nightRoutine) {
    return null;
  }

  return (
    <Wrapper>
      <div>
        <DomeHeader text="Tailored For You" />
        <Header2>How It Works</Header2>
        <Body>
          Complete your self-care ritual every morning and every night with
          these steps. Remember, skin care is health care.
        </Body>
        <SegmentControl active={mode} setActive={setMode} data={data} />
        {data.morningRoutine && mode === 0 && (
          <div>
            {data.morningRoutine.map((r, i) => (
              <HowToUseRow
                index={i + 1}
                title={r.stepTitle}
                image={r.stepImage.fluid}
                copy={r.extraCopy}
              />
            ))}
          </div>
        )}
        {data.nightRoutine && mode === 1 && (
          <div>
            {data.nightRoutine.map((r, i) => (
              <HowToUseRow
                index={i + 1}
                title={r.stepTitle}
                image={r.stepImage.fluid}
                copy={r.extraCopy}
              />
            ))}
          </div>
        )}
      </div>
    </Wrapper>
  );
}
